
import { ApiProperty } from '@nestjs/swagger'
import { IsArray, IsUUID } from 'class-validator'

/**
 * DTO pour la requête batch de ressources
 */
export class GetResourcesBatchRequestDto {
  @ApiProperty({
    description: 'IDs des ressources à récupérer',
    type: [String],
    example: [
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e51',
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e52',
    ],
  })
  @IsArray()
  @IsUUID(undefined, { each: true })
  resourceIds!: string[]
}
